{% block sw_cms_element_acris_blog_group_config %}
    <div class="sw-cms-el-config-acris-blog-group">
        <sw-tabs defaultItem="general">
            <template #default="{ active }">
                <sw-tabs-item :title="$tc('acris-blog.elements.blogGroup.config.tab.general')"
                              name="general"
                              :activeTab="active">
                    {{ $tc('acris-blog.elements.blogGroup.config.tab.general') }}
                </sw-tabs-item>

                <sw-tabs-item :title="$tc('acris-blog.elements.blogGroup.config.tab.boxLayout')"
                              v-if="element.config.layout.value === 'box'"
                              name="boxLayout"
                              :activeTab="active">
                    {{ $tc('acris-blog.elements.blogGroup.config.tab.boxLayout') }}
                </sw-tabs-item>

                <sw-tabs-item :title="$tc('acris-blog.elements.blogGroup.config.tab.listing')"
                              v-if="element.config.layout.value === 'box'"
                              name="listing"
                              :activeTab="active">
                    {{ $tc('acris-blog.elements.blogGroup.config.tab.listing') }}
                </sw-tabs-item>
            </template>

            <template #content="{ active }">
                <div v-if="active === 'general'">
                    {% block sw_cms_element_acris_blog_config_group_entity %}
                        <sw-entity-multi-id-select
                                :repository="blogGroup"
                                labelProperty="internalName"
                                :label="$tc('acris-blog.elements.blogGroup.config.label.groups')"
                                :helpText="$tc('acris-blog.elements.blogGroup.config.label.groupsHelpText')"
                                v-model:value="element.config.groups.value">
                        </sw-entity-multi-id-select>
                    {% endblock %}

                    <sw-container columns="1fr 1fr" gap="0 16px">
                        {% block sw_cms_element_acris_blog_config_blog_post_per_page %}
                            <mt-number-field v-model="element.config.blogPostsPerPage.value"
                                             :label="$tc('acris-blog.elements.blogGroup.config.label.blogPostsPerPage')"
                                             number-type="int"
                                             :step="1">
                            </mt-number-field>
                        {% endblock %}
                        {% block sw_cms_element_acris_blog_config_pagination_horizontal_alignment %}
                            <mt-select v-model="element.config.paginationHorizontalAlignment.value"
                                       :label="$tc('acris-blog.elements.blogGroup.config.label.paginationHorizontalAlignment')"
                                       :options="paginationHorizontalAlignmentOptions">
                            </mt-select>
                        {% endblock %}
                    </sw-container>

                    <sw-container columns="1fr 1fr" gap="0 16px">
                        {% block sw_cms_element_acris_blog_config_post_limit %}
                            <mt-number-field v-model="element.config.blogPostsLimit.value"
                                             :label="$tc('acris-blog.elements.blogGroup.config.label.blogPostsLimit')"
                                             :helpText="$tc('acris-blog.elements.blogGroup.config.label.blogPostsLimitHelpText')"
                                             number-type="int"
                                             :step="1"
                                             allow-empty>
                            </mt-number-field>
                        {% endblock %}
                    </sw-container>

                    <sw-container columns="1fr 1fr" gap="0 16px">
                        {% block sw_cms_element_acris_blog_config_post_layout %}
                            <mt-select v-model="element.config.layout.value"
                                       :label="$tc('acris-blog.elements.blogGroup.config.label.layout')"
                                       :options="layoutOptions">
                            </mt-select>
                        {% endblock %}
                    </sw-container>
                </div>

                <div v-if="active === 'boxLayout' && element.config.layout.value === 'box'">
                    <mt-banner
                            variant="info">{{ $tc('acris-blog.elements.blogGroup.config.articleSettings.infoText.settings') }}</mt-banner>

                    <sw-container v-for="(item, key) in element.config.articleSettings.value"
                                  class="sw-cms-el-config-acris-blog-group__collapse-container" columns="1fr auto">
                        <sw-collapse>
                            <template #header="{ expanded }">
                                <mt-icon v-if="expanded"
                                         name="regular-chevron-up-xxs"
                                />

                                <mt-icon v-else
                                         name="regular-chevron-down-xxs"
                                />

                                <h4>
                                    {{ $tc('acris-blog.elements.blogGroup.config.articleSettings.' + key ) }}
                                </h4>
                            </template>

                            <template #content>
                                <sw-container columns="1fr 1fr" gap="0 8px">
                                    <mt-switch v-model="item.active"
                                               :label="$tc('acris-blog.elements.blogGroup.config.label.active')"
                                               bordered>
                                    </mt-switch>

                                    <mt-number-field v-model="item.position"
                                                     :label="$tc('acris-blog.elements.blogGroup.config.label.position')"
                                                     :helpText="$tc('acris-blog.elements.blogGroup.config.label.helpText.position')"
                                                     :min="1"
                                                     :max="8"
                                                     :step="1"
                                                     @change="movePosition(key, item.position)">
                                    </mt-number-field>
                                </sw-container>

                                <sw-container columns="1fr 1fr" gap="0 8px" v-if="key !== 'image' && key !== 'button'">
                                    <mt-colorpicker v-model="item.fontColor"
                                                    :label="$tc('acris-blog.elements.blogGroup.config.label.fontColor')"
                                                    color-output="hex"
                                                    :z-index="1001"
                                                    :alpha="false">
                                    </mt-colorpicker>

                                    <mt-number-field v-model="item.fontSize"
                                                     :label="$tc('acris-blog.elements.blogGroup.config.label.fontSize')"
                                                     number-type="int"
                                                     :min="0"
                                                     :step="1"
                                                     allow-empty>
                                        <template #suffix>px</template>
                                    </mt-number-field>
                                </sw-container>

                                <template v-if="key === 'button'">
                                    <mt-text-field v-model="item.text"
                                                   :label="$tc('acris-blog.elements.blogGroup.config.label.buttonText')">
                                    </mt-text-field>
                                    <sw-container columns="1fr 1fr" gap="0 8px">
                                        <mt-select v-model="item.type"
                                                          :options="buttonTypeOptions"
                                                          :label="$tc('acris-blog.elements.blogGroup.config.label.buttonType')">
                                        </mt-select>

                                        <mt-switch v-model="item.outline"
                                                   :label="$tc('acris-blog.elements.blogGroup.config.label.buttonOutline')"
                                                   bordered>
                                        </mt-switch>
                                    </sw-container>
                                </template>

                                <sw-container v-if="key === 'image'" columns="1fr 1fr" gap="0 8px">
                                    <mt-select v-model="item.displayMode"
                                                      :options="displayModeOptions"
                                                      :label="$tc('acris-blog.elements.blogGroup.config.label.displayMode')">
                                    </mt-select>

                                    <mt-number-field v-model="item.minHeight"
                                                     :label="$tc('acris-blog.elements.blogGroup.config.label.minHeight')"
                                                     number-type="int"
                                                     :disabled="item.acris_image_fixed_aspect_ratio_active === true || item.displayMode === 'stretch'"
                                                     :min="0"
                                    >
                                        <template #suffix>px</template>
                                    </mt-number-field>

                                    <mt-switch v-model="item.acris_image_fixed_aspect_ratio_active"
                                               :label="$tc('acris-blog.elements.blogGroup.config.imageOptimisation.fieldFixedAspectRatioLabel')"
                                               bordered>
                                    </mt-switch>
                                </sw-container>

                                <div v-if="item.acris_image_fixed_aspect_ratio_active === true"
                                     v-for="(viewport, key) in item.acris_image_fixed_aspect_ratio_viewports"
                                     class="viewport">
                                    <div class="own-ratio-title">
                                        {{ $tc('acris-blog.elements.blogGroup.config.imageOptimisation.' + key) }}
                                    </div>
                                    <div class="own-ratio-value">
                                        <mt-button v-if="key !== 'acris_image_settings_xl'"
                                                   class="image-linked-button"
                                                   variant="TODO-Codemod-Variant-Context-Was-Removed" size="small"
                                                   @click="onImageLinkedClick(key)">
                                            <mt-icon v-if="viewport.linked === true"
                                                     key="inherit-icon"
                                                     name="regular-link-horizontal"/>
                                            <mt-icon v-else key="uninherit-icon" name="regular-link-horizontal-slash"/>
                                        </mt-button>

                                        <mt-select v-model="viewport.aspect_width"
                                                          :disable-search-function="true"
                                                          :label="$tc('acris-blog.elements.blogGroup.config.imageOptimisation.fieldAspectWidthLabel')"
                                                          :disabled="viewport.linked === true"
                                                          :popoverClasses="aspectRatioSelectClasses"
                                                          :options="aspectRatioOptions"
                                                          @change="onAspectChange('aspect_width', viewport.aspect_width, key)"/>
                                        <p class="ratio-separator">/</p>
                                        <mt-select v-model="viewport.aspect_height"
                                                          :disable-search-function="true"
                                                          :label="$tc('acris-blog.elements.blogGroup.config.imageOptimisation.fieldAspectHeightLabel')"
                                                          :disabled="viewport.linked === true"
                                                          :popoverClasses="aspectRatioSelectClasses"
                                                          :options="aspectRatioOptions"
                                                          @change="onAspectChange('aspect_height', viewport.aspect_height, key)"/>
                                    </div>

                                </div>
                            </template>
                        </sw-collapse>

                        <div class="sw-cms-el-config-acris-blog-group__collapse-actions">
                            <mt-switch v-model="item.active"></mt-switch>
                            <mt-button square
                                       :disabled="item.position === 1"
                                       size="small"
                                       @click="movePosition(key, item.position - 1)" variant="secondary">
                                <mt-icon name="regular-chevron-up-xxs"></mt-icon>
                            </mt-button>

                            <mt-button square
                                       size="small"
                                       :disabled="item.position === 7"
                                       @click="movePosition(key, item.position + 1)" variant="secondary">
                                <mt-icon name="regular-chevron-down-xxs"></mt-icon>
                            </mt-button>
                        </div>
                    </sw-container>
                </div>

                <div v-if="active === 'listing' && element.config.layout.value === 'box'">
                    <sw-container columns="1fr 1fr" gap="0 16px">
                        <mt-select v-model="element.config.blogColumnsXL.value"
                                   :label="$tc('acris-blog.elements.blogGroup.config.label.blogColumnsXL')"
                                   :options="blogColumnOptions">
                        </mt-select>

                        <mt-select v-model="element.config.blogColumnsLG.value"
                                   :label="$tc('acris-blog.elements.blogGroup.config.label.blogColumnsLG')"
                                   :options="blogColumnOptions">
                        </mt-select>

                        <mt-select v-model="element.config.blogColumnsMD.value"
                                   :label="$tc('acris-blog.elements.blogGroup.config.label.blogColumnsMD')"
                                   :options="blogColumnOptions">
                        </mt-select>

                        <mt-select v-model="element.config.blogColumnsSM.value"
                                   :label="$tc('acris-blog.elements.blogGroup.config.label.blogColumnsSM')"
                                   :options="blogColumnOptions">
                        </mt-select>

                        <mt-select v-model="element.config.blogColumnsXS.value"
                                   :label="$tc('acris-blog.elements.blogGroup.config.label.blogColumnsXS')"
                                   :options="blogColumnOptions">
                        </mt-select>
                    </sw-container>
                </div>
            </template>
        </sw-tabs>
    </div>
{% endblock %}


